import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const UniversityIcon = React.memo(
  ({ width = 47, fill = variables['colors-mc-university-icon'], viewBox = '0 0 47 47' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <rect
        id='Rectangle_1421'
        data-name='Rectangle 1421'
        width='47'
        height='47'
        rx='23.5'
        fill={fill}
      />
      <g id='Layer_2' data-name='Layer 2' transform='translate(13.993 13.993)'>
        <g id='Layer_1' data-name='Layer 1'>
          <path
            id='Path_12343'
            data-name='Path 12343'
            d='M18.658,14.977v3.644H0V14.977H.882V12.9h.947V7.4H0V4.3L8.461.4c.279-.13.555-.267.832-.4h.073c.068.036.134.078.2.109L18.658,4.3V7.4H16.79v5.508h1.4v2.072ZM1.093,6.279H17.564c0-.384-.007-.754,0-1.124a.21.21,0,0,0-.151-.227Q13.443,3.1,9.473,1.268a.3.3,0,0,0-.287,0Q7.4,2.1,5.618,2.915q-2.181,1-4.359,2.012c-.065.03-.156.1-.158.158C1.087,5.477,1.093,5.872,1.093,6.279Zm16.465,9.812H1.1v1.426H17.558Zm-.476-2.084H1.982v.966h15.1ZM7.528,7.4H5.4v5.489H7.528Zm3.562,5.49h2.123V7.4H11.09Zm-6.8,0V7.4H2.952V12.9ZM8.645,7.4v5.492H9.98V7.4Zm7.028,5.5V7.4H14.335v5.5Z'
            fill='#fff'
          />
          <path
            id='Path_12344'
            data-name='Path 12344'
            d='M209.655,64.992a1.67,1.67,0,1,1,1.672,1.668,1.685,1.685,0,0,1-1.672-1.668Zm2.247-.011a.577.577,0,1,0-.572.568A.577.577,0,0,0,211.9,64.981Z'
            transform='translate(-202.015 -61.003)'
            fill='#fff'
          />
        </g>
      </g>
    </svg>
  )
);
UniversityIcon.displayName = 'UniversityIcon';

export default UniversityIcon;
